import { createContext, FC, useEffect, useMemo, useState } from 'react';
import { useApi } from '@repo-level/core-front';
import { fetchConfig } from 'api/cms/config';
import { isNowBetween } from 'modules/common/helpers';

interface IConfigContextData {
  quest: {
    start: string;
    end: string;
  } | null;
  isQuestDateValid: boolean;
}

interface IConfigContextActions {}

const initialValues = {
  quest: null,
  isQuestDateValid: false,
};

export const ConfigContext = createContext<
  IConfigContextData & IConfigContextActions
>(null as any);

export const ConfigContextProvider: FC = ({ children }) => {
  const [state, setState] = useState<IConfigContextData>(initialValues);
  const [requestConfig, { data }] = useApi(fetchConfig);

  useEffect(() => {
    requestConfig();
  }, [requestConfig]);

  useEffect(() => {
    if (data) {
      setState((prevState) => ({ ...prevState, ...data }));
    }
  }, [data]);

  const isQuestDateValid = useMemo(() => {
    if (state.quest === null) return false;
    return isNowBetween(state.quest.start, state.quest.end);
  }, [state.quest]);

  return (
    <ConfigContext.Provider value={{ ...state, isQuestDateValid }}>
      {children}
    </ConfigContext.Provider>
  );
};
